<div>

  <div class="my-show-table">



    <!-- TABLE -->
    <div class="mat-elevation-z8 ex">

      <table mat-table [dataSource]="sessions" matSort>

        <!-- SESSION ID -->
        <ng-container matColumnDef="id">

          <th mat-header-cell *matHeaderCellDef class="header">
            ID
          </th>

          <td mat-cell *matCellDef="let s">
            <span class="mono">{{ s.id }}</span>
          </td>

        </ng-container>

        <!-- User NAME -->
        <ng-container matColumnDef="target_user_name">

          <th mat-header-cell *matHeaderCellDef class="header">
            User Name
          </th>

          <td mat-cell *matCellDef="let s" class="text">
            <b>{{ s.target_user_name || '-'  }}</b>
          </td>

        </ng-container>

        <!-- EMAIL -->
        <ng-container matColumnDef="target_user_email">

          <th mat-header-cell *matHeaderCellDef class="header">
            User Email
          </th>

          <td mat-cell *matCellDef="let s">
            <small>{{ s.target_user_email }}</small>
          </td>

        </ng-container>

        <!--  Admin NAME -->
        <!-- <ng-container matColumnDef="admin_name">

          <th mat-header-cell *matHeaderCellDef>
            Agent Name
          </th>

          <td mat-cell *matCellDef="let s">
            <b>{{ s.admin_name }}</b>
          </td>

        </ng-container> -->

        <!-- Admin EMAIL -->
        <ng-container matColumnDef="admin_email">

          <th mat-header-cell *matHeaderCellDef class="header">
            Agent Email
          </th>

          <td mat-cell *matCellDef="let s">
            <small>{{ s.admin_email }}</small>
          </td>

        </ng-container>

        <!-- CREATED AT -->
        <ng-container matColumnDef="created_at">

          <th mat-header-cell *matHeaderCellDef mat-sort-header class="header">
            Created At
          </th>

          <td mat-cell *matCellDef="let s" class="text">
            {{ s.created_at | date:'short' }}
          </td>

        </ng-container>

        <!-- IP -->
        <ng-container matColumnDef="granted_by_ip" >

          <th mat-header-cell *matHeaderCellDef class="header">
            IP
          </th>

          <td mat-cell *matCellDef="let s" class="text">
            {{ s.granted_by_ip }}
          </td>

        </ng-container>

        <!-- ACTIONS (ICON ONLY) -->
        <ng-container matColumnDef="actions">

          <th mat-header-cell *matHeaderCellDef class="header">
            Logs
          </th>

          <td mat-cell *matCellDef="let s">

            <button mat-icon-button color="primary" (click)="openActionsPopup(s)" class="header">
              <mat-icon>visibility</mat-icon>
            </button>

          </td>

        </ng-container>

        <!-- STATUS -->
        <ng-container matColumnDef="status">

          <th mat-header-cell *matHeaderCellDef class="header">
            Status
          </th>

          <td mat-cell *matCellDef="let s">

            <span class="status" [ngClass]="s.status === 'INACTIVE' ? 'ended' : 'active'">
              {{ s.status }}
            </span>

          </td>

        </ng-container>

        <!-- HEADER ROW -->
        <tr mat-header-row *matHeaderRowDef="columns"></tr>

        <!-- DATA ROW -->
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td colspan="8" class="mat-cell">{{ sessionLoader ? 'Loading...' : 'No sessions history found.'}}</td>
        </tr>

      </table>

      <!-- PAGINATION -->
      <mat-paginator [length]="total" [pageSize]="limit" [pageSizeOptions]="[50, 100, 250]" (page)="onPage($event)">
      </mat-paginator>

    </div>

  </div>

</div>